// extracted by mini-css-extract-plugin
export default {"discount-cta":"eeoX10","discountCta":"eeoX10"};